import {
  Outlet,
  createFileRoute,
  retainSearchParams,
} from "@tanstack/react-router";

import { ProjectPageProvider } from "@/features/project/components/pages/project-page-context";
import {
  holdingProjectSearchSchema,
  loadHoldingProject,
} from "@/features/project/lib/holding-project-route";

export const Route = createFileRoute("/_protected/fas/projects/$id")({
  component: FasProjectRoute,
  validateSearch: holdingProjectSearchSchema,
  search: {
    middlewares: [retainSearchParams(["entityProjectId"])],
  },
  beforeLoad: (args) => loadHoldingProject(args),
});

function FasProjectRoute() {
  const { id } = Route.useParams();

  return (
    <ProjectPageProvider value={{ module: "fas", projectId: id }}>
      <Outlet />
    </ProjectPageProvider>
  );
}
